import { createSlice } from "@reduxjs/toolkit";

export type WindowManagerState = {
	devMode: boolean;
};

const initialState: WindowManagerState = {
	devMode: false,
};

export const systemSlice = createSlice({
	name: "system",
	initialState,
	reducers: {
		enableDevMode: (state) => {
			state.devMode = true;
		},
		disableDevMode: (state) => {
			state.devMode = false;
		},
		toggleDevMode: (state) => {
			state.devMode = !state.devMode;
		},
	},
});

export const { enableDevMode, disableDevMode, toggleDevMode } =
	systemSlice.actions;

export default systemSlice.reducer;
